import { apiClient } from '@/api/client';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { useEntityDrawer } from '@/hooks/useEntityDrawer';
import { queryKeys } from '@/lib/queryKeys';
import * as React from 'react';
import { AppVersionDrawer } from './components/AppVersionDrawer/index';
import { AppVersionsList } from './components/AppVersionsList';
import { useAppVersionMutations } from './hooks/useAppVersionMutations';
import { AppVersion, AppVersionFormData } from './types';

export const AppVersionsPage: React.FC = () => {
  const { state, actions } = useEntityDrawer<AppVersion>({
    basePath: '/app-versions',
    queryKey: queryKeys.ADMIN_APP_VERSIONS,
    fetchFn: async (id: number) => {
      const response = await apiClient.GET('/admin/app-versions/{id}', {
        params: { path: { id } },
      });
      if (response.error) throw new Error('Failed to fetch app version');
      return response.data as AppVersion;
    },
    supportsCreate: true,
  });

  const {
    actions: mutationActions,
    isFormLoading,
    isDeleting,
  } = useAppVersionMutations();

  const handleFormSubmit = async (formData: AppVersionFormData) => {
    await mutationActions.handleFormSubmit(formData, state.mode, state.entity);
  };

  return (
    <DashboardLayout>
      <ProtectedRoute action='read' subject='AppVersion'>
        <AppVersionsList
          onRowClick={appVersion => actions.open(appVersion.id!)}
          onEditAppVersion={appVersion => actions.edit(appVersion.id!)}
          onDeleteAppVersion={mutationActions.handleDelete}
          onCreateAppVersion={actions.create}
          isDeleting={isDeleting}
        />

        <AppVersionDrawer
          onFormSubmit={handleFormSubmit}
          onDeleteAppVersion={mutationActions.handleDelete}
          isFormLoading={isFormLoading}
        />
      </ProtectedRoute>
    </DashboardLayout>
  );
};
